import { renderPage } from "renderPage"
import { SearchAdvertIndexPage } from "./Page"

renderPage({ component: SearchAdvertIndexPage })
